export default {
  email_address: 'email',
  has_explicit_template_access: 'hasExplicitTemplateAccess',
  is_admin: 'isAdmin',
  is_owner: 'isOwner',
};
